module.exports = __webpack_public_path__ + "img/landinglogo2.4c7fdbf5.png";